
import type { ExplainMessages } from '../../../models'
import { defineComponent, getCurrentInstance } from 'vue'
import ToolingPreviewNoResults from '../../tooling/tooling-preview-no-results.component.vue'

export default defineComponent({
  name: 'SearchDataNoResults',
  components: {
    ToolingPreviewNoResults,
  },
  setup() {
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const messages = ($epb.messages.explain as ExplainMessages).queryAnalysis.sections.searchData
      .noResults

    return {
      messages,
    }
  },
})
